import { toast } from "react-hot-toast";
import { CreateForm } from "./CreateForm";
import { apiNiches } from "services";
import { upload } from "utils/gifUploader";
import { FieldValues } from "react-hook-form";
import { ToastMessage } from "./ToastMessage";
import { DUPLICATE_CODE } from "./constants";

interface ICreateFormContainerProps {
  handleGoSuccess: () => void;
}

export const CreateFormContainer = (props: ICreateFormContainerProps) => {
  const { handleGoSuccess } = props;

  const getError = (e: any) => {
    if (e?.code === DUPLICATE_CODE) {
      if (e.public) {
        return toast.custom(<ToastMessage id={e.niche_id} />, { duration: 10000 });
      } else {
        return toast.error(e.message, { duration: 5000 });
      }
    }

    toast.error("Error submitting the niche, please try again later.", { duration: 5000 });
  };

  const onSubmit = async (data: FieldValues) => {
    try {
      const { id } = await upload(data.image[0], () => {});
      await apiNiches.createNiche({
        name: data.name,
        description: data.description,
        rules: data.rules,
        profile_image: id
      });
      handleGoSuccess();
    } catch (e: any) {
      console.error(e);
      getError(e.response.data.error);
    }
  };

  return (
    <CreateForm onSubmit={onSubmit} />
  );
};

